import { render, staticRenderFns } from "./StoreUpdateTag.vue?vue&type=template&id=41567322&scoped=true&"
import script from "./StoreUpdateTag.vue?vue&type=script&lang=ts&"
export * from "./StoreUpdateTag.vue?vue&type=script&lang=ts&"
import style0 from "./StoreUpdateTag.vue?vue&type=style&index=0&id=41567322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41567322",
  null
  
)

export default component.exports